"use client"

import { useState } from "react"
import styled from "@emotion/styled"
import { motion, AnimatePresence } from "framer-motion"
import { AnimatedBadge } from "./animated-badge"

const ViewerContainer = styled(motion.div)`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  order: 2;

  @media (max-width: 1024px) {
    order: 1;
    aspect-ratio: 4 / 3;
  }
`
const BikeImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
`

const FeaturePoint = styled(motion.div)`
  position: absolute;
  width: 16px;
  height: 16px;
  background: #008000;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 4px rgba(0, 128, 0, 0.2);
  
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 128, 0, 0.3);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    100% { transform: scale(2.5); opacity: 0; }
  }
`

const FeatureTooltip = styled(motion.div)`
  position: absolute;
  background: rgba(0, 0, 0, 0.95);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  width: max-content;
  max-width: 200px;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(0, 128, 0, 0.2);
  border: 1px solid rgba(0, 128, 0, 0.3);
  font-size: 0.9rem;
  line-height: 1.4;
`


const FloatingPrice = styled(motion.div)`
  position: absolute;
  bottom: 120px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  font-size: 1.25rem;
  font-weight: bold;
  z-index: 10;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    bottom: 10px;
    right: 10px;
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
`

const PriceLabel = styled.span`
  font-size: 0.8em;
  font-weight: normal;
  margin-right: 0.5rem;
  opacity: 0.8;
`


export function BikeViewer({ img, price, text }) {

  return (
    <ViewerContainer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <AnimatedBadge text={text}/>

      <BikeImage
        src={img}
        alt="Bicicleta Java Siluro"
      />
        <FloatingPrice
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <PriceLabel>Precio:</PriceLabel>
        {price}
      </FloatingPrice>
    </ViewerContainer>
  )
}

